import React from 'react'

export default function Analytics() {

  return (
    <div className="pt-14 ml-60 dark:text-white">
      Analytics
    </div>
  )
}